"use strict";

var _classCallCheck = require("/var/nobackup/jenkins/jobs/DDI Frontend/branches/release-2022-04.94hkrn/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/var/nobackup/jenkins/jobs/DDI Frontend/branches/release-2022-04.94hkrn/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/var/nobackup/jenkins/jobs/DDI Frontend/branches/release-2022-04.94hkrn/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _get = require("/var/nobackup/jenkins/jobs/DDI Frontend/branches/release-2022-04.94hkrn/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/get");

var _getPrototypeOf = require("/var/nobackup/jenkins/jobs/DDI Frontend/branches/release-2022-04.94hkrn/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/var/nobackup/jenkins/jobs/DDI Frontend/branches/release-2022-04.94hkrn/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ToolbarSeparator = void 0;

var ToolbarIcon_1 = require("./ToolbarIcon");
/* import * as SNAPSVG_TYPE from "snapsvg";
declare var Snap: typeof SNAPSVG_TYPE; */


var ToolbarSeparator = /*#__PURE__*/function (_ToolbarIcon_1$Toolba) {
  _inherits(ToolbarSeparator, _ToolbarIcon_1$Toolba);

  function ToolbarSeparator(paper, width) {
    var _this;

    _classCallCheck(this, ToolbarSeparator);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ToolbarSeparator).call(this, paper, null));

    _this.buildIconUI();

    _this.resize(width, 1);

    return _this;
  }

  _createClass(ToolbarSeparator, [{
    key: "move",
    value: function move(x, y) {
      _get(_getPrototypeOf(ToolbarSeparator.prototype), "move", this).call(this, x, y);

      this.iconSeparator.attr({
        x1: x,
        x2: x + this.width,
        y1: y,
        y2: y
      });
    }
  }, {
    key: "resize",
    value: function resize(width, height) {
      _get(_getPrototypeOf(ToolbarSeparator.prototype), "resize", this).call(this, width, 1);

      this.iconSeparator.attr({
        width: this.width
      });
    }
  }, {
    key: "buildIconUI",
    value: function buildIconUI() {
      this.node = this.paper.g();
      this.node.addClass("iconStyle");
      this.node.addClass("separator");
      this.iconSeparator = this.paper.line(0, 0, this.width, 0);
      this.node.add(this.iconSeparator);
    }
  }]);

  return ToolbarSeparator;
}(ToolbarIcon_1.ToolbarIcon);

exports.ToolbarSeparator = ToolbarSeparator;